import { ModeloProyecto } from "./modeloProyecto";

export class ProyectosLote {
    idEmpresa?: number = 1;
    idEmpresaAfiliada?: Number = 1;
    idProyecto?: number = -1;
    idLote: number = -1;
    idsLote: string = "";
    nombre: string = "";
    descripcion: string = "";
    numeroLote: number = -1;
    estatus: string = "";
    modelo: ModeloProyecto = new ModeloProyecto();
    m2?: number = -1;
    m2ex?: number = -1;
    costo?: number = 0;
    precio?: number = 0;
    precioLote?: number = 0;
    precioFinal?: number = 0;
    precioPorM2?: number = -1;
    precioM2ex?: number = -1;
    idModelo?: number = -1;
    idCierre?: number = -1;
    porcentajeUbicacionLote?: number = -1;
    porcentajeUbicacionModelo?: number = -1;
    nivel?: number = -1;
    etapa?: number = -1;
    precioM2Actualizado?: number = 0;
    idDisponibilidad?: number = 0;
    nombreModelo?: string = "";
    montoVenta?: number = 0;
    modeloAsignado?: number = 0;
    equipamientos?: string = "";
    costoEquipamientos: number = 0;
    idsEquipamientos?: string = "";
    incrementoLote_precioFinal_validacion?: number = 0;
    precioFinal_sin_incremento?: number = 0;
    tipoVista?: string = "";
    idCategoria?: number = -1;
    fechaFormalizacion?: Date = new Date();
    fechaVenta?: Date = new Date();
    fechaAutorizacion?: Date = new Date();
    categoriaNombre?: string = "";
    reserva?: number = 0;

}

export class Lote_Reserva_ReglasHorario {
    idLote: number = 0;
    idHorario: number = 0;
    fechaHoraUM: Date = new Date();
    idUsuarioUM: number;
}